import React from "react";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import { useSelector } from "react-redux";
import useTranslate from "@default/hooks/use-translate";
import UniversalSliderButton from "@default/general-components/universal-slider-button";

const SwiperSimpleNavigation = ({ prevRef, nextRef, centerSelector }) => {
  const { simpleDesign } = useAccessibilityContext();
  const microSite = useSelector((reduxStore) => reduxStore.appStore.microSite);
  const _t = useTranslate();

  if (microSite) {
    return (
      <>
        {/* Custom Navigation Buttons */}
        <button
          ref={prevRef}
          className="custom-swiper-button swiper-button-prev"
          aria-label={_t("accessibility.previous_slide")}
        >
          <span aria-hidden="true">←</span>
        </button>
        <button
          ref={nextRef}
          className="custom-swiper-button swiper-button-next"
          aria-label={_t("accessibility.next_slide")}
        >
          <span aria-hidden="true">→</span>
        </button>
      </>
    );
  } else {
    return (
      <>
        <UniversalSliderButton
          type="prev"
          buttonRef={prevRef}
          centerSelector={centerSelector}
        />
        <UniversalSliderButton
          type="next"
          buttonRef={nextRef}
          centerSelector={centerSelector}
        />
      </>
    );
  }
};

export default SwiperSimpleNavigation;
